module.exports = __webpack_public_path__ + "fwm_h5/img/MiaoshijunLogo.e4b679f8.png";